import React from 'react';

import MediaPreview from './component';

export default React.memo(MediaPreview);
